import { IDefaultSearchResult } from '../interface';
import { SearchService } from './SearchService';

export class SearchKeyword<TFacets extends string, ISearchResult> {
	protected _inputElement: JQuery<HTMLInputElement>;
	protected _searchService: SearchService<TFacets, IDefaultSearchResult>;

	protected _handleKeywordSearch: (value: string) => void;

	constructor(
		input: JQuery<HTMLInputElement>,
		searchService: SearchService<TFacets, IDefaultSearchResult>,
		handleSearch: (value: string) => void,
	) {
		this._inputElement = input;
		this._searchService = searchService;

		this._handleKeywordSearch = handleSearch;

		if (this._inputElement.length) {
			this._inputElement.on('input', event => {
				const value = event.target.value;

				this._handleKeywordSearch(value);
			});
		}
	}

	public setFocus() {
		this._inputElement.focus();
	}
}


// WEBPACK FOOTER //
// ./scripts/algolia/SearchKeyword.ts